import theme from './theme';

export const basicStyles = `

html {
  height: 100%;
  background: #fff;
}
body {
  height: 100%;
  padding: 0;
  margin: 0;
  font-family: ${theme.fontFamily} !important;
  /* https://developer.mozilla.org/en-US/docs/Web/CSS/-webkit-overflow-scrolling */
  -webkit-overflow-scrolling: touch;
}
#root {
  height: 100%
}
nav {
  img {
    padding-top: 10px;
  }
}
div, a, span, p, h1, h2, h3, h4, h5, h6, th, tr, button {
  font-family: ${theme.fontFamily} !important;
}
@media screen and (min-width: 700px) {
  nav {
    img {
      padding-top: 10px;
      position: absolute;
      left: 16px;
    }
  }
}

#plan-carousel {
  .slick-list {
    height: 1000px;
    @media only screen and (max-width: 400px) {
      height: 600px;
    }
  
  }
}



#embedContainer  { 
  width: 100% !important;
  height: 100% !important;
  position: relative !important;
  overflow: scroll;
  iframe {
    border: 0 !important;
    width: 100% !important;
    height: 100% !important;
    position: relative !important;
  }
}

#fullscreenContentWrapper {
  width: 100% !important;
  height: 100% !important;
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  #fullscreenContentWrapper {
    max-width: 1300px;
    max-height: 700px !important;
    height: 100% !important;
    position: relative !important;
  }
}


.fullscreen {
  position: absolute !important;
  top: 20px !important;
  bottom: 0 !important;
  right: 0 !important;
  left: 0 !important;
}

.fullscreen-enabled {
  top: 0 !important;
  position: absolute !important;
  bottom: 0 !important;
  right: 0 !important;
  left: 0 !important;
}



a {
  color: ${theme.color.primary} !important;
  height: 16px;
}



.dark-select > .ant-select-selection {
  background-color: ${theme.colorDark1} !important;
}


input:-webkit-autofill {
  box-shadow: 0 0 0px 1000px white inset; /* https://stackoverflow.com/questions/45917350/input-text-background-color-is-set-as-yellow-only-in-chrome */
}

.contract-step-container {
  min-height: 95vh; 
  background-color: #FBFCFC;
  flex-direction: column;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  padding: 40px;
  @media (max-width: 769px) {
    padding: 15px;
  }
}


.headway-widget-wrapper {
  width: 100%;
  max-width: 100%;
  padding-left: 15px;

  .headwayappwidget {
      width: 100%;
      padding: 10px 0;
      display: flex;
      align-items: center;
  }

  .headway-text {
      color: #fff;
  }
}

.sidemenu-bottom {
  position: fixed;
  bottom: 0;
}


.contract-flow-btn {
  display: block;
  min-width: 225px;
  height: 45px;
  font-size: 18;
  max-width: 100%;
  &:disabled {
    border-color: #d9d9d9 !important;
    background-color: #d9d9d9 !important;
  }
}

h1, h2, h3, h4, h5, h6, p {
  margin: 0px;
}


input, textarea, select, option, textarea::placeholder, input::placeholder {
  font-family: ${theme.fontFamily} !important;
  font-size: 14px !important;
}

textarea::placeholder, input::placeholder {
  color: #ccc;
}

p.signature-text {
  font-family: 'Cedarville Cursive' !important;
}

.line-item-container {
  border: 1px solid #efefef;
  min-height: 50px;
  @media (max-width: 769px) {
     min-height: 100px;
     text-align: center;
  }
}

.middle-invoice-item-col {
  text-align: left;
  padding-left: 5px;
  @media (max-width: 769px) {
     text-align: center;
     padding: 0px;
  }
}

.money-green {
  color: #2ecc71;
}

.invoice-component {
  padding: 80px;
  color: #4D4D4D;
  background-color: white;
  box-shadow: 0 3px 8px rgba(0,0,0,0.1);
  width: 100%;
  background: #FFF;
  @media (max-width: 769px) {
     padding: 15px;
  }
}

.contract-step-container {
  min-height: 95vh; 
  background-color: #FBFCFC;
  flex-direction: column;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  padding: 40px;
  @media (max-width: 769px) {
    padding: 15px;
  }
}


`;

export default basicStyles;



// WEBPACK FOOTER //
// ./src/lib/theme/basicStyles.js